import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=5de64eda&lang=pug"
import script from "./ResultList.vue?vue&type=script&lang=js"
export * from "./ResultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports